import React from "react";
import FifthPage from "./FifthPage";
import FirstPage from "./FirstPage";
import FourthPage from "./FourthPage";
import SecondPage from "./SecondPage";
import SixthPage from "./SixthPage";
import ThirdPage from "./ThirdPage";

function Home() {
  return (
    <>
      <FirstPage />
      <SecondPage />
      <ThirdPage />
      <FourthPage />
      <FifthPage />
      <SixthPage />
    </>
  );
}

export default Home;
